import dayjs from 'lib/dayjs'

export const formatLocalTime = (
	date: string | number,
	formatData: string
): string => {
	const timeZone: string = dayjs.tz.guess()
	const formattedDate: string = dayjs.utc(date).tz(timeZone).format(formatData)
	return formattedDate
}
